var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-flex',{staticClass:"d-md-flex justify-md-center"},[_c('div',{staticClass:"page-top-margin",staticStyle:{"width":"100%","max-width":"1400px"}},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }